module.exports = __webpack_public_path__ + "img/SMALL_N_LOGO.dc909a55.png";